module.exports = "/static/core/dist/ajax-loader.gif";